import classnames from "classnames";
import React from "react";
import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  svg {
    width: 100%;
    height: 100%;
  }
  &.withColor {
    svg path {
      fill: currentColor;
    }
  }
  &.ghost {
    padding: 4px;
    box-sizing: content-box;
    border-radius: 4px;
    &:hover {
      background: rgba(53, 57, 77, 0.05);
    }
  }
`;
type SVGIconProps = {
  width?: number;
  height?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  icon?: React.ReactNode;
  ghost?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};
const SVGIcon = (props: SVGIconProps) => {
  const {
    style,
    width = 16,
    height,
    color,
    onClick,
    className,
    icon,
    ghost,
    ...restProps
  } = props;
  return (
    <Container
      onClick={onClick}
      className={classnames("svg-icon", ghost ? "ghost" : "", color ? "withColor" : "", className)}
      style={{
        width: `${width / 100}rem`,
        height: `${height || width / 100}rem`,
        color,
        ...style,
      }}
      {...restProps}
    >
      {icon}
    </Container>
  );
};
export default SVGIcon;
